import { Link, SpriteIcon } from '@coolblue-development/freddy';
import clickAllTrigger from '@coolblue-development/ga4-events/triggers/ProductSpecifications/clickAllTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { scrollToTarget } from '@utils/utils';

type FullSpecificationsLinkProps = {
  onMobileClick: () => void;
  children: React.ReactNode;
  isComposed?: boolean;
};

export default function FullSpecificationsLink({
  children,
  onMobileClick,
  isComposed
}: FullSpecificationsLinkProps) {
  const { isMobile } = useBreakpoints();
  const { trackEvent } = useAnalytics();

  const onClick = (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
  ): void => {
    trackClick();

    if (isMobile) {
      onMobileClick();

      return;
    }

    scrollToTarget('product-specifications')(
      event as React.MouseEvent<HTMLAnchorElement, MouseEvent>
    );
  };

  function trackClick() {
    if (isComposed) {
      trackEvent(clickAllTrigger({ sub_feature: 'composed_content' }));
      return;
    }

    trackEvent(
      clickAllTrigger({
        sub_feature: 'short_specifications'
      })
    );
  }

  return (
    <Link
      mt={200}
      onClick={onClick}
      startIcon={<SpriteIcon name='arrow-right' />}
      {...(isMobile
        ? { component: 'button' }
        : { component: 'a', href: '#product-specifications' })}
    >
      {children}
    </Link>
  );
}
